interface LauncherButtonProps {
  onClick: () => void;
}

const LauncherButton = ({ onClick }: LauncherButtonProps) => (
  <div
    onClick={onClick}
    className="fixed right-7 bottom-7 z-40 flex items-center justify-center w-[60px] h-[60px] rounded-full cursor-pointer shadow-lg"
    style={{
      background: 'linear-gradient(135deg, #317690, #163544)',
      boxShadow: '0 12px 28px rgba(15,23,42,0.28)',
    }}
    role="button"
    aria-label="Open Prowl assistant"
    tabIndex={0}
    onKeyDown={(e) => e.key === 'Enter' && onClick()}
  >
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
      <circle cx="9" cy="8" r="3.2" stroke="white" strokeWidth="1.6" />
      <circle cx="19" cy="8" r="3.2" stroke="white" strokeWidth="1.6" />
      <path
        d="M6 20c0-4.4 3.6-8 8-8s8 3.6 8 8"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <circle cx="14" cy="18" r="1.4" fill="white" />
    </svg>
    {/* Online pulse dot */}
    <div
      className="absolute top-[2px] right-[2px] w-3 h-3 rounded-full border-2 border-white"
      style={{
        background: '#16A34A',
        animation: 'hp-pulse 2s infinite',
      }}
    />
  </div>
);

export default LauncherButton;
